// extracted by mini-css-extract-plugin
export default {"panel":"Offices_panel__HB-7m"};